import type { FC } from "react";
import { Icon } from "../common/Icon";
import { SimpleTooltip } from "../common/SimpleTooltip";
import { useFeatureFlag } from "../hooks/use-app-metadata";
import {
	formatMinutes,
	useActiveVideoGenerations,
} from "./useVideoGenerations";

/** Story 6.1: "Video in progress" chip on a calendar item, with queue position and estimate. */
export const VideoProgressChip: FC<{ postId: number }> = ({ postId }) => {
	const flagOn = useFeatureFlag("HeyGenVideoGeneration");
	const active = useActiveVideoGenerations(flagOn);
	const video = active.get(postId);
	if (!video) {
		return null;
	}
	const eta = video.estimatedWaitSeconds
		? `ready in about ${formatMinutes(video.estimatedWaitSeconds)}`
		: "in progress";
	const tooltip =
		video.status === "queued"
			? `Video waiting to start${video.queuePosition ? ` (#${video.queuePosition} in line)` : ""}, ${eta}`
			: `Video being made (${video.progress}%), ${eta}`;
	return (
		<SimpleTooltip tooltip={tooltip} placement="bottom">
			<span
				className="badge rounded-pill text-bg-info d-inline-flex align-items-center gap-1"
				style={{ fontSize: 10, flexShrink: 0 }}
			>
				<Icon name="movie" size={12} />
				{video.status === "queued" && video.queuePosition
					? `#${video.queuePosition}`
					: "Video"}
			</span>
		</SimpleTooltip>
	);
};
